import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth-guard';
import { billingLockGuard } from './core/auth/billing-lock-guard';

export const routes: Routes = [
  // Public routes - no auth required
  {
    path: 'legal',
    loadChildren: () => import('./features/legal/legal.routes').then(m => m.legalRoutes)
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.authRoutes)
  },
  {
    path: 'share/order/:token',
    loadComponent: () => import('./features/share/order-share-page').then(m => m.OrderSharePage)
  },
  {
    path: 'share/:token',
    loadComponent: () => import('./features/share/share-page').then(m => m.SharePage)
  },
  // Root redirect (pathMatch full so '' only matches exactly /, not /legal etc.)
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  // Billing hard-lock suspension page: standalone, no dashboard shell, no org
  // data. billingLockGuard and the 402 interceptor redirect here.
  {
    path: 'suspended',
    loadComponent: () => import('./features/suspended/suspended-page').then(m => m.SuspendedPage)
  },
  // Auth-required dashboard. billingLockGuard runs before the shell loads so a
  // hard-locked org never fetches workspace data client-side.
  {
    path: 'dashboard',
    canActivate: [authGuard, billingLockGuard],
    loadChildren: () => import('./features/dashboard/dashboard.routes').then(m => m.dashboardRoutes)
  },
  // Catch-all: redirect to dashboard (e.g. /projects from old links -> /dashboard)
  { path: '**', redirectTo: 'dashboard' }
];
